module.exports = __webpack_public_path__ + "img/icon_float.b0b44540.png";